var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-container",class:{ 'hide': this.hidden }},[_c('button',{staticClass:"floating-button",style:(_vm.floatingButtonStyles),on:{"click":_vm.action}},[_c('v-icon',{attrs:{"name":this.iconName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }